export default __webpack_public_path__ + "static/media/chart.657ea68a.svg";